/** The Secrets page's words that depend on the server it talks to (R-TP: a hub or Orgus Cloud). */
import type { ServerKind } from '../server/server.ts';

/**
 * Where the master key comes from, worded for the server: on Orgus Cloud it is derived from the
 * control plane's sealing key (SECRETS_KEY, set by whoever deploys it); on a hub (a computer or a
 * Docker container) from ORGUS_SECRETS_KEY, the OS keystore or a key file in the hub folder.
 */
export function masterKeyCopy(server: ServerKind, source: 'env' | 'keystore' | 'file', keystore?: string | null): string {
  if (server === 'cloud') return 'Sealed by Orgus Cloud';
  if (source === 'env') return 'From ORGUS_SECRETS_KEY';
  if (source === 'keystore') return `In ${keystore ?? 'the OS keystore'}`;
  return 'Key file in the hub folder';
}

/** What to do when stored secrets cannot be opened, worded for the server. */
export function lockedNext(server: ServerKind): string {
  if (server === 'cloud') return 'Ask whoever runs this Orgus Cloud to restore the sealing key it was deployed with. Until then nothing is leased.';
  return 'Start the hub with the ORGUS_SECRETS_KEY it used before, or without it as the user whose OS keystore holds the key (or with secrets/master.key restored in the hub folder). Until then nothing is leased.';
}
